// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

export const customPalette = {
  black: "rgba(0, 0, 0, 1)",
  blue: {
    light1: "rgba(200, 229, 255, 1)",
    link: "rgb(55, 118, 174)",
  },
  green: {
    light1: "rgba(43, 105, 105, 0.03)",
    light2: "rgba(43, 84, 105, 0.1)",
    light3: "rgba(193, 227, 216, 0.24)",
    light4: "rgba(0, 102, 95, 0.4)",
    highlight: "#00C49D",
  },
  white: {
    white1: "rgba(249, 250, 250, 1)",
    white2: "rgba(233, 237, 237, 1)",
  },
  grey: {
    light1: "rgba(244, 246, 247, 1)",
    grey3: "rgba(0, 17, 51, 1)",
    grey4: "#C5C5C5",
    grey5: "#DFDFDF",
    grey6: "#B0B0B0",
    grey7: "#AAAAAA",
    grey8: "#5D5D5D",
    dark: "#505050",
  },
  teal: "rgba(204, 242, 235, 1)",
  lightred: "rgba(180, 45, 45, 0.08)",
};
